import { TextareaAutosize } from "@mui/material";
import "./text-area.scss";

export interface TextAreaProps {
  //react-hook-form props
  register: any;
  getFieldState: any;
  formState: any;
  errors?: any;
  //input props
  name: string;
  value?: string;
  label?: string;
  placeholder?: string;
  assistiveText?: string;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
}

export function TextArea(props: TextAreaProps) {
  const { isDirty } = props.getFieldState(props.name, props.formState);

  return (
    <div className="text-area-container">
      {props.register && (
        <TextareaAutosize
          defaultValue={props.value}
          placeholder=""
          className={`custom-text-area
        ${props.getFieldState(props.name).invalid && "invalid-text-area"}
        ${
          !props.getFieldState(props.name).invalid &&
          (isDirty || props.value) &&
          "valid-text-area"
        }
        `}
          onFocus={(e) => {
            e.target.placeholder = props.placeholder ? props.placeholder : "";
          }}
          {...props.register(props.name)}
          onBlur={(e) => {
            e.target.placeholder = "";
          }}
          autoComplete="no"
          disabled={props.disabled}
          maxLength={props.maxLength}
        ></TextareaAutosize>
        // <textarea
        //   defaultValue={props.value}
        //   placeholder=""
        //   className={`custom-text-area
        //   ${props.getFieldState(props.name).invalid && "invalid-text-area"}
        //   ${
        //     !props.getFieldState(props.name).invalid &&
        //     (isDirty || props.value) &&
        //     "valid-text-area"
        //   }
        //   `}
        //   onFocus={(e) => {
        //     e.target.placeholder = props.placeholder ? props.placeholder : "";
        //   }}
        //   {...props.register(props.name)}
        //   onBlur={(e) => {
        //     e.target.placeholder = "";
        //   }}
        //   autoComplete="no"
        //   disabled={props.disabled}
        //   maxLength={props.maxLength}
        // ></textarea>
      )}

      {props.label && (
        <label
          className={`text-area-label ${props.disabled && "disabled"} ${
            isDirty || props.value ? "filled" : ""
          }`}
        >
          {props.label} {props.required && <span>*</span>}
        </label>
      )}
      {props.assistiveText && (
        <p className="assistive-text">{props.assistiveText}</p>
      )}

      {props.errors && props.errors[props.name] && (
        <p className="error">{props.errors[props.name]?.message?.toString()}</p>
      )}
    </div>
  );
}

export default TextArea;
